import './styles.scss';
import { Email } from 'react-obfuscate-email'
import { useAuth } from 'reactfire';
const signOut = auth => auth.signOut().then(() => console.log('signed out'));

export default function CMSHome(props) {
  const auth = useAuth()
  return (
    <div className='CMSUnauthorized'>
      You are not authorized to view this page, please contact <Email email='nick@pitchinteractive.com'>nick@pitchinteractive.com</Email> to request access.
      <br />
      <button onClick={() => signOut(auth)}>Sign out</button>

    </div>
  )
}
